export default "__VITE_ASSET__u1gfAiS5__"